import { Drawer } from 'antd'
import React, { useMemo } from 'react'
import useSWR from 'swr'

import { fetcher } from '../../../api'
import { drawerAndModalWidth } from '../../../util/guideline'
import { Tenant } from '../models'
import { UpdateTenant } from './UpdateTenant'

interface UpdateTenantDrawerProps {
  tenantId: number
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateTenantDrawer = ({ tenantId, isVisible, onClose, onSuccess }: UpdateTenantDrawerProps) => {
  const { data: tenants } = useSWR<Tenant[]>('/tenants', fetcher, { suspense: true })

  const segmentCodes = useMemo(() => {
    const allSegmentCodes = tenants.map(({ segmentCode }) => segmentCode)

    return Array.from(new Set(allSegmentCodes)).sort()
  }, [tenants])

  return (
    <Drawer
      title="Update Tenant"
      placement="right"
      onClose={onClose}
      open={isVisible}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <UpdateTenant tenantId={tenantId} onSuccess={onSuccess} segmentCodes={segmentCodes} />
    </Drawer>
  )
}
